import React, { Component } from 'react'
import { Popover, Button, Upload, message } from 'antd'
import { FileAddOutlined, UploadOutlined } from '@ant-design/icons';
import fileApi from '.././../api/fileApi'
import './UploadPanel.scss'

export default class UploadPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    componentDidMount() {

    }
    componentDidUpdate() {

    }
    componentWillUnmount() {

    }
    onChange(info) {
        console.log(info);
        // if (info.file.status !== 'uploading') {
        //     console.log(info.file, info.fileList);
        // }
        // if (info.file.status === 'done') {
        //     message.success(`${info.file.name} file uploaded successfully`);
        // } else if (info.file.status === 'error') {
        //     message.error(`${info.file.name} file upload failed.`);
        // }
        var form = new FormData(); // FormData 对象
        form.append("file", info.file)
        fileApi.fileUpload(form).then(res=>{
            console.log(res);
        })
    }
    content = () => {
        return <div><Upload
            name='file'
            action='https://www.mocky.io/v2/5cc8019d300000980a055e76'
            headers={{ authorization: 'authorization-text' }}
            customRequest={this.onChange}
        ><Button icon={<UploadOutlined />}>上传</Button></Upload></div>
    }
    render() {
        return (
            <div id="UploadPanel">
                <Popover content={this.content} title="" trigger="click" placement="right">
                    <Button type="primary"><FileAddOutlined /></Button>
                </Popover>
            </div>
        )
    }
}
